import React, { useMemo } from 'react';
import { required, useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import keys from 'lodash/keys';
import { useField } from 'react-final-form';
import { SelectInput } from '../../../../base/components/ra/inputs';
import resourceSlug from '../../../../constant/resource-slug';
import ResetOnFieldChange from '../../../../base/components/customized/ResetOnFieldChange';

const DefaultLanguageSelect = (props) => {
  const t = useTranslate();
  const languages = useSelector(({ admin }) => admin.resources[resourceSlug.LANGUAGE]?.data || {});
  const {
    input: { value: selectedLanguages },
  } = useField('languages');

  const choices = useMemo(
    () =>
      keys(languages).length === 0
        ? []
        : (selectedLanguages || []).map((item) => ({
            id: languages[item.id].id,
            name: languages[item.id].name,
          })),
    [selectedLanguages, languages],
  );

  return (
    <>
      <SelectInput
        source="defaultLanguage"
        validate={required(t('ra.validation.required'))}
        label="resources.brand.fields.defaultLanguage"
        choices={choices}
        parse={(id) => ({
          id,
        })}
        format={(item) => item?.id || item}
        emptyText={t('resources.brand.chooseLanguagesFirst')}
        {...props}
      />
      <ResetOnFieldChange
        watchField="languages"
        resetFields={['defaultLanguage']}
        type="exclusion"
        includingFn={(currentValue, watchedValue) => watchedValue?.find((item) => item.id === currentValue.id)}
      />
    </>
  );
};

export default DefaultLanguageSelect;
